module.exports = __webpack_public_path__ + "img/mi_cobro.9e932c16.png";